import React, { useState } from 'react';

interface CopyToClipboardProps {
  toCopy: string|(() => Promise<string|null>);
  children: React.ReactNode;
  className?: string;
  copiedText?: string;
  absolute?: boolean;
  onCopied?: () => void;
}

export const CopyToClipboard: React.FC<CopyToClipboardProps> = ({
  toCopy,
  children,
  className,
  copiedText = 'Copied to clipboard',
  absolute = true,
  onCopied
}) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async (text: string|(() => Promise<string|null>)) => {
        if(typeof text === 'function') {
            const functionResult = await text();
            if(functionResult === null) {
                return;
            }
            text = functionResult;
        }

        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            // Add a subtle animation class when copying
            setTimeout(() => {
                setCopied(false);
                if(onCopied) onCopied();
            }, 1500);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <div className={`relative ${className}`}>
            <div 
                className={`cursor-pointer ${copied ? 'invisible' : ''} ${!absolute && copied && 'hidden'}`} 
                onClick={() => handleCopy(toCopy)}
            >
                {children}
            </div>
            {
                copied && (
                    <div className={`
                        ${absolute ? 'absolute top-1/2 transform -translate-y-1/2' : ''} 
                        flex flex-row justify-center items-center gap-2
                    `}>
                        <i 
                            className="material-icons text-[18px]"
                        >
                            check
                        </i>
                        <span className="break-words [word-break:break-word]">
                            {copiedText}
                        </span>
                    </div>
                )
            }
        </div>
    );
}